var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48262 6.192L2.86562 12.1645L2.60162 15.3076L5.57862 15.0194L11.1786 9.05863L8.48262 6.192ZM14.4673 5.56025L11.7723 2.69574L9.82428 4.76704L12.5193 7.63367L14.4673 5.56025ZM1.5912 17.5405C1.5602 17.5437 1.5302 17.5448 1.5002 17.5448C1.2362 17.5448 0.9812 17.4342 0.7932 17.2332C0.5832 17.0099 0.4772 16.6994 0.5042 16.3858L0.8832 11.9508C0.9252 11.4649 1.1272 11.0066 1.4522 10.661L10.4482 1.09458C11.1502 0.346027 12.4242 0.383242 13.1642 1.16901L15.9022 4.08031H15.9032C16.6692 4.89585 16.6992 6.18988 15.9712 6.96608L6.9742 16.5325C6.6492 16.8791 6.2192 17.0929 5.7612 17.1375L1.5912 17.5405ZM1.5 19.6714H15.5C16.05 19.6714 16.5 20.1499 16.5 20.7347C16.5 21.3195 16.05 21.798 15.5 21.798H1.5C0.95 21.798 0.5 21.3195 0.5 20.7347C0.5 20.1499 0.95 19.6714 1.5 19.6714Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a48307768d7fc5713ff0112538013c41.svg";
export { ForwardRef as ReactComponent };